import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    dashboardData: [],
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setDashboardsData: (state, action) => {
            state.dashboardData = action.payload;
        },
    },
});

export const { setDashboardsData } = dashboardSlice.actions;

export default dashboardSlice.reducer;
